import React from "react"
import Wrapper from "@components/Wrapper"
import styles from "./Highlights.module.scss"

const Card = props => {
  return (
    <div className={props.className}>
      <img className="mb-5" src={props.imgSrc} alt={props.imgAlt}></img>
      {props.children}
    </div>
  )
}

const CardContent = props => {
  return (
    <p className="proxima-nova--semi-bold fs-18pt mx-auto mb-8">
      <span className="d-inline-block">{props.line1}</span>{" "}
      <span className="d-inline-block">{props.line2}</span>
    </p>
  )
}

const Highlights = props => {
  return (
    <div className={styles.fullWidth}>
      <div className={styles.videoParent}>
        <iframe className={styles.video}
          width="100%" height="100%"
          src="https://www.youtube.com/embed/LsRqdVg-MkM"
          title="EngineID and SailPoint Technical Demonstration"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          frameBorder="0"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default Highlights
